module.exports = __webpack_public_path__ + "static/media/Rafael_Makrigiorgis.84c46ebc.jpg";